module.exports = ["belt-pulley", "gear-box", "coupling", "coupled", "CAMshaftBased","universal-joint"];